import { IApiLpAdapterSetting } from '@cbridge-packages/api';
import { ApiLpErrorResolutionPolicy } from '@cbridge-packages/api-admin';
import { ITenant } from '@cbridge-packages/tenant';
import { NetworkStatus } from '@cbridge-utils/network';

export enum LpGatewayStatus {
  Active = 'active',
  Backup = 'backup',
  Error = 'error',
}

export interface IGatewayLp {
  available: boolean;
  id: string;
  name: string;
  status: LpGatewayStatus;
}

export enum LpConnectionStatus {
  Backup = 'backup',
  Error = 'error',
  Offline = 'offline',
  Online = 'online',
  Disabled = 'disabled',
}

export interface ILpConnectionState {
  error?: string;
  status: LpConnectionStatus;
}

export interface ILp {
  lpId: number;
  name: string;
  region: string;
  adapter: string;
  enabled: boolean;
  throttlingInterval?: number;
  errorResolutionPolicy: ApiLpErrorResolutionPolicy;
  resetSeqNumFlagSupported: boolean;
  pricing: ILpConnectionState;
  trading: ILpConnectionState;
  gateways: IGatewayLp[];
}

export interface ILpAdapterSetting extends IApiLpAdapterSetting {
  id: number;
}

export interface ILpConnectionForm {
  host?: string;
  port?: number;
  login?: string;
  password?: string;
  adapterSettings?: ILpAdapterSetting[];
}

export interface ILpForm {
  name?: string;
  region?: string;
  adapter?: string;
  enabled?: boolean;
  throttlingInterval?: number | null;
  errorResolutionPolicy?: ApiLpErrorResolutionPolicy;
  resetSeqNumFlagSupported?: boolean;
  pricing?: ILpConnectionForm;
  trading?: ILpConnectionForm;
  gateway1?: string;
  gateway2?: string;
  gateway3?: string;
}

export interface ILpKey {
  lpId: ILp['lpId'];
  tenantId?: ITenant['tenantId'];
}

export type ILpConnectionType = 'pricing' | 'trading';

export interface ILpListKey {
  tenantId: ITenant['tenantId'];
}

export interface ILpListFilter {
  search?: string;
}

export interface ILpStore {
  data: Record<ILp['lpId'], ILpForm>;
  list: ILp[];
  filter: ILpListFilter;
  networkStatus: NetworkStatus;
}

export interface ILpStoreSegment {
  lp: ILpStore;
}
